import { useLocation } from 'react-router-dom'
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';
import messages from '../assets/Messages.json'
import { showLoading } from 'react-global-loading';



export const GetPageName = (userRoleObject = '') => {

  const location = useLocation();

  if (typeof userRoleObject.userRole !== undefined && userRoleObject.userRoleType === 'SUPER ADMIN USER') {

    switch (location.pathname) {
      case '/dashboard':
        return {
          pagePath: ['Dashboard'],
          pageName: 'Dashboard'
        }
      case '/addUser':
        return {
          pagePath: ['Account Management', 'User Management', ' Create New User'],
          pageName: 'addUser'
        };
      case '/listUsers':
        return {
          pagePath: ['Account Management', 'User Management', ' View user List'],
          pageName: 'listUsers'
        };
      case '/changePwd':
        return {
          pagePath: ['Change Password'],
          pageName: 'changePwd'
        }
      case '/FrequentlyAskQuestion':
        return {
          pagePath: ['Frequently Ask Questions'],
          pageName: 'FrequentlyAskQuestion'
        }
      default:
        return {
          pagePath: ['Not Found'],
          pageName: 'Not Found'
        }
    }

  } else {
    switch (location.pathname) {
      case '/':
        return {
          pagePath: ['Home'],
          pageName: 'Home'
        };
      case '/dashboard':
        return {
          pagePath: ['Dashboard'],
          pageName: 'Dashboard'
        }

      case '/PricePendency':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Pendency Report'],
          pageName: 'PricePendency'
        }

      case '/RejectedPriceWagesReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Rejected Price Wages Report'],
          pageName: 'PricePendency'
        }
      case '/PricePendencyAcceptReject':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'New Pendency Report'],
          pageName: 'PricePendencyAcceptReject'
        }
      case '/urban-consumer-retail-price-graph':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System',
            'Graph Report', 'Urban Consumer Retail Price Graph'],
          pageName: 'urban-consumer-retail-price-graph'
        }
      case '/rular-consumer-retail-price-graph':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System',
            'Graph Report', 'Rural Consumer Retail Price Graph Report'],
          pageName: 'rular-consumer-retail-price-graph'
        }
      case '/sixty-seven-graph':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System',
            'Graph Report', 'Sixty Seven Necessary Items Graph Report'],
          pageName: 'sixty-seven-graph'
        }
      case '/wholesale-price-graph':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System',
            'Graph Report', 'Wholesale Price Graph Report'],
          pageName: 'wholesale-price-graph'
        }
      case '/UrbanConsumerPriceInputForm':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Consumer Retail Price', 'Urban Consumer Retail Price'],
          pageName: 'UrbanConsumerPriceInputForm'
        }
      case '/RuralConsumerPriceInputForm':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Consumer Retail Price', 'Rural Consumer Retail Price'],
          pageName: 'RuralConsumerPriceInputForm'
        }
      case '/UrbanCommonSixItemPriceForm':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Consumer Retail Price', 'Urban Common Six Items Retail Price'],
          pageName: 'UrbanCommonSixItemPriceForm'
        }
      case '/RuralCommonSixItemPriceForm':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Consumer Retail Price', 'Rural Common Six Items Retail Price'],
          pageName: 'RuralCommonSixItemPriceForm'
        }
      case '/WholeSalePriceInputForm':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Whole Sale Price'],
          pageName: 'WholeSalePriceInputForm'
        }
      case '/urban_lws':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Labour Wages', 'Urban Wages'],
          pageName: 'urban_lws'
        }
      case '/SixtySevenNecessaryItems':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Sixty Seven Necessary Items'],
          pageName: 'urban_lws'
        }
      case '/WholeSaleKanpurDistrict':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Whole Sale Kanpur District'],
          pageName: 'urban_lws'
        }
      case '/PriceForAnimalProduct':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Whole Sale Price of Animal Product'],
          pageName: 'urban_lws'
        }
      case '/WholeSaleRawWool':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Whole Sale Raw Wool'],
          pageName: 'WholeSaleRawWool'
        }
      case '/WholeSalePriceForAgriHapurMandi':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Whole Sale Price For Agriculture Items of Hapur Mandi'],
          pageName: 'WholeSalePriceForAgriHapurMandi'
        }
      case '/PriAgricultureProrityFormOne':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Price Agriculture Parity Form for Bull'],
          pageName: 'PriAgricultureProrityFormOne'
        }
      case '/PriAgricultureProrityFormTwo':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Price Agriculture Parity Form Miscellaneous'],
          pageName: 'PriAgricultureProrityFormTwo'
        }
      case '/PriAgricultureProrityFormTwo1':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Other Prices', 'Price Agriculture Parity Form For Electricity'],
          pageName: 'PriAgricultureProrityFormTwo1'
        }
      case '/RuralWagesRatesForMen':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Labour Wages', 'Rural Men Wages'],
          pageName: 'RuralWagesRatesForMen'
        }
      case '/LwsRuralWageRatesForWomen':
        return {
          pagePath: ['Data Capture', 'Price Wages Indices System',
            'Labour Wages', 'Rural Women Wages'],
          pageName: 'LwsRuralWageRatesForWomen'
        }
      case '/IIPManufacturingSector':
        return {
          pagePath: ['Data Capture', 'IIP',
            'Monthly Production Details', 'Manufacturing Sector'],
          pageName: 'IIPManufacturingSector'
        }
      case '/IIPMiningSector':
        return {
          pagePath: ['Data Capture', 'IIP',
            'Monthly Production Details', 'Mining Sector'],
          pageName: 'IIPMiningSector'
        }
      case '/IIPElectricitySector':
        return {
          pagePath: ['Data Capture', 'IIP',
            'Monthly Production Details', 'Electricity Sector'],
          pageName: 'IIPElectricitySector'
        }
      case '/IIPEstimationReport':
        return {
          pagePath: ['Data Capture', 'IIP',
            'Monthly Production Details', 'Estimation Report'],
          pageName: 'IIPEstimationReport'
          }
      case '/AgriculturalProductionDetails':
        return {
          pagePath: ['Data Capture', 'IIP', 'Annual Agriculture Production Details',
            'Annual Agriculture Production Details'],
          pageName: 'AgriculturalProductionDetails'
        }
        case '/CentralStoreFigures':
          return {
            pagePath: ['Data Capture', 'IIP', 'Central Store Figures'],
            pageName: 'CentralStoreFigures'
          }
      case '/BlockA':
      case '/BlockB':
      case '/BlockC':
      case '/BlockD':
      case '/BlockE':
      case '/BlockF':
      case '/BlockG':
      case '/BlockH':
      case '/BlockI':
      case '/BlockJ':
      case '/BlockK':
      case '/BlockL':
      case '/BlockM':
      case '/BlockN':
        return {
          pagePath: ['Data Capture', 'ASI', 'ASI'],
          pageName: 'BlockA'
        }
      case '/UploadPage':
        return {
          pagePath: ['Data Capture', 'ASI', 'ASI Data Upload'],
          pageName: 'UploadPage'
        }
        case '/balanceSheet':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI', 'Balance Sheet'],
            pageName: 'balanceSheet'
          }
        case '/asiScheduleMainMenu':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI', 'Balance Sheet', 'ASI Schedule Main Menu'],
            pageName: 'asiScheduleMainMenu'
          }
        case '/fixedAssets':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI', 'Balance Sheet', 'Fixed Assets'],
            pageName: 'fixedAssets'
          }
        case '/balanceSheetData':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI', 'Balance Sheet', 'Balance Sheet Data'],
            pageName: 'balanceSheetData'
          }
        case '/profitAndLossAccount':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI', 'Balance Sheet', 'Profit and Loss Account'],
            pageName: 'profitAndLossAccount'
          }
        case '/employmentAndLabourCost':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Employment and Labour Cost'],
            pageName: 'employmentAndLabourCost'
          }
        case '/input-items':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Input Items Indigenous'],
            pageName: 'inputItemsIndigenous'
          }
        case '/input-items-imported':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Input Items Imported'],
            pageName: 'inputItemsImported'
          }
        case '/products-and-by-products':
          return {
            pagePath: ['Data Capture', 'ASI','Balance Sheet', 'Products and By-products'],
            pageName: 'productsAndByProducts'
          }
        case '/ict-usage-energy-conservation':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'ICT Usage and Energy Conservation'],
            pageName: 'ictUsageAndEnergyConservation'
          }
        case '/part-a':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Part A-1'],
            pageName: 'partA'
          }
        case '/final-checklist':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Final Checklist'],
            pageName: 'finalChecklist'
          }
          
        case '/particulars-of-field-operations':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Particulars of Field Operations'],
            pageName: 'particularsOfFieldOperations'
          }
        case '/validation':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet', 'Validation'],
            pageName: 'validation'
          }
        case '/fixed-assets-data':
          return {
            pagePath: ['Data Capture', 'ASI', 'ASI','Balance Sheet','Validation', 'Fixed Assets Data'],
            pageName: 'fixedAssetsData'
          }
        case '/balance-sheet-data-check':
          return {
            pagePath: ['Data Capture', 'ASI','Balance Sheet','Validation', 'Balance Sheet Data Check'],
            pageName: 'balanceSheetDataCheck'
          }
        case '/check-pl-account':
          return {
            pagePath: ['Data Capture', 'ASI','ASI','Balance Sheet','Validation', 'Check PL Account'],
            pageName: 'checkPLAccount'
          }
        case '/check-pl-account-sorted':
          return {
            pagePath: ['Data Capture', 'ASI','ASI','Balance Sheet','Validation', 'Check PL Account Sorted'],
            pageName: 'checkPLAccountSorted'
          }
        case '/net-profit-tally':
          return {
            pagePath: ['Data Capture', 'ASI','ASI','Balance Sheet','Validation', 'Net Profit Tally'],
            pageName: 'netProfitTally'
          }
        case '/error-list':
          return {
            pagePath: ['Data Capture', 'ASI','ASI','Balance Sheet','Validation', 'Error List'],
            pageName: 'errorList'
          }
        case '/reports':
          return {
            pagePath: ['Data Capture', 'ASI','ASI','Balance Sheet','Reports'],
            pageName: 'reports'
          }
        case '/report-selection':
          return {
            pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection'],
            pageName: 'reportSelection'
          }
          //report selection
        case '/blockAandBreport':
          return {
            pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block A and B Report'],
            pageName: 'Block A and B Report'
          }
          case '/blockCreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block C Report'],
                pageName: 'Block C Report'
              }
          case '/blockDreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block D Report'],
                pageName: 'Block D Report'
              }
          case '/blockEreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block E Report'],
                pageName: 'Block E Report'
              }
          case '/blockFreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block F Report'],
                pageName: 'Block F Report'
              }
          case '/blockGreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block G Report'],
                pageName: 'Block G Report'
              }
          case '/blockHreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block H Report'],
                pageName: 'Block H Report'
              }
          case '/blockIreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block I Report'],
                pageName: 'Block I Report'
              }
          case '/blockJreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block J Report'],
                pageName: 'Block J Report'
              }
          case '/blockKAndLreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block K and L Report'],
                pageName: 'Block K and L Report'
              }
          case '/blockMAndNreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Block M and N Report'],
                pageName: 'Block M and N Report'
              }
          case '/partIIreport':
              return {
                pagePath: ['Data Capture', 'ASI','ASI', 'Balancesheet', 'Report Selection', 'Part II Report'],
                pageName: 'partIIreport'
              }
           case '/scrutiny-sheet':
              return {
                pagePath: ['Data Capture', 'ASI', 'ASI', 'Balancesheet', 'Report Selection', 'Scrutiny Sheet'],
                pageName: 'scrutinySheet'
              }
     
        case '/block-c':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block C'],
            pageName: 'blockC'
          }
        case '/block-d':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block D'],
            pageName: 'blockD'
          }
        case '/block-e':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block E'],
            pageName: 'blockE'
          }
        case '/block-f':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block F'],
            pageName: 'blockF'
          }
        case '/block-g':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block G'],
            pageName: 'blockG'
          }
        case '/block-h':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block H'],
            pageName: 'blockH'
          }
        case '/block-i':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block I'],
            pageName: 'blockI'
          }
        case '/block-j':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block J'],
            pageName: 'blockJ'
          }
        case '/block-kl':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block K and L'],
            pageName: 'blockKL'
          }
        case '/block-mn':
          return {
            pagePath: ['Data Capture', 'ASI', 'Block M and N'],
            pageName: 'blockMN'
          }
        // case '/part-ii':
        //   return {
        //     pagePath: ['Data Capture', 'ASI', 'Part II'],
        //     pageName: 'partII'
        //   }
        
      case '/changePwd':
        return {
          pagePath: ['Change Password'],
          pageName: 'changePwd'
        }
      case '/FrequentlyAskQuestion':
        return {
          pagePath: ['Frequently Ask Questions'],
          pageName: 'FrequentlyAskQuestion'
        }
      case '/GetASICountPendencyReportNew':
        return {
          pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Total No. of New Pending DSL Report'],
          pageName: 'GetASICountPendencyReportNew'
        }
      case '/GetASIPendencyReport':
        return {
          pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Pending DSL No. Report'],
          pageName: 'GetASIPendencyReport'
        }
      case '/GetASICountPendencyReport':
        return {
          pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Total No. of Pending DSL Report'],
          pageName: 'GetASICountPendencyReport'
        }
      case '/GetASIPendencyReportDistrict':
        return {
          pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Pendency Report For District'],
          pageName: 'GetASIPendencyReportDistrict'
        }
      case '/GetASIPendencyReportMandal':
        return {
          pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Pendency Report For Mandal'],
          pageName: 'GetASIPendencyReportMandal'
        }
      case '/GetASIPendencyReportHQ':
        return {
          pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Pendency Report For HQ'],
          pageName: 'GetASIPendencyReportHQ'
        }
        case '/GetASIRejectedDSLReport':
          return {
            pagePath: ['Report Generation', 'ASI', 'Pendency Report', 'Rejected DSL Report'],
            pageName: 'GetASIRejectedDSLReport'
          }

      case '/GetListingReportHQ':
        return {
          pagePath: ['Report Generation', 'IIP', 'Listing Report', 'Listing Report For HQ'],
          pageName: 'GetListingReportHQ'
        }

      case '/IIPNICBasedReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'NIC Based Report', 'NIC Based Report for HQ'],
          pageName: 'IIPNICBasedReport'
        }

      case '/GetPendencyReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'Pendency Report'],
          pageName: 'GetPendencyReport'
        }

      case '/IIPAnnualAgricultureReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'IIP Annual Agriculture Report', 'Annual Agriculture Report For HQ'],
          pageName: 'GetIIPAnnualAgricultureReport'
        }
      case '/IIPManufacturingMonthWisePendency':
        return {
          pagePath: ['Report Generation', 'IIP', 'Monthly Pendency Report'],
          pageName: 'IIPManufacturingMonthWisePendency'
        }
       



      //ASI HQ Report


      case '/ASITable1':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 1'],
          pageName: 'ASITable1'
        }


      case '/ASITable2':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 2'],
          pageName: 'ASITable2'
        }

      case '/ASITable3':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 3'],
          pageName: 'ASITable3'
        }

      case '/ASITable4':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 4'],
          pageName: 'ASITable4'
        }

      case '/ASITable5':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 5'],
          pageName: 'ASITable5'
        }

      case '/ASITable6':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 6'],
          pageName: 'ASITable6'
        }



      case '/ASITable7':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Table For HQ 7'],
          pageName: 'ASITable7'
        }

      case '/DownloadASIBlockData':
        return {
          pagePath: ['Report Generation', 'ASI', 'ASI Block'],
          pageName: 'DownloadASIBlockData'
        }
      case '/getASIListingReport':
        return {
          pagePath: ['Report Generation', 'ASI','Listing Report'],
          pageName: 'getASIListingReport'
        }


      case '/Multiplier':
        return {
          pagePath: ['Report Generation', 'ASI', 'HQ Report', 'Multiplier'],
          pageName: 'Multiplier'
        }
        
        case '/BlockAReport':
        return {
          pagePath: ['Report Generation', 'ASI','Filled DSL Report'],
          pageName: 'BlockAReport'
        }

        case '/ASIOtherReport':
        return {
          pagePath: ['Report Generation', 'ASI','Other ASI Reports'],
          pageName: 'ASIOtherReport'
        }


      // Mining Report

      case '/IIPMiningReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Mining Report'],
          pageName: 'GetIIPMiningReport'
        }

      case '/IIPElectricityReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Electricity Report'],
          pageName: 'IIPElectricityReport'
        }

      // General Index Report

      case '/IIPGeneralReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'General Index Report'],
          pageName: 'GetIIPGeneralReport'
        }


      case '/IIPIndexReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Index Report'],
          pageName: 'IIPIndexReport'
        }


      case '/IIPTop5Index':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Top 5 Index Report'],
          pageName: 'IIPTop5Index'
        }

      case '/IIPBottom5Index':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Bottom 5 Index Report'],
          pageName: 'IIPBottom5Index'
        }

      case '/IIPMajorGroupIndexReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Major Group Index Report'],
          pageName: 'IIPMajorGroupIndex'
        }
          case '/IIPFRQRReport':
            return {
                  pagePath:['Report Generation','IIP','HQ Report','Manufacturing Sector','FR/QR Report'],
                  pageName:'IIPFRQRReport'
             }
          case '/IIPFRQRReportArchive':
            return {
                  pagePath:['Report Generation','IIP','HQ Report','Manufacturing Sector','FR/QR Report Archive'],
                  pageName:'IIPFRQRReportArchive'
             }
          // case '/IIPMajorGroupIndexReport':
          //   return {
          //         pagePath:['Report Generation','IIP','HQ Report','Manufacturing Sector','Major Group Index Report'],
          //         pageName:'IIPMajorGroupIndex'
          //         }

      case '/GetGroupIndexAnnualReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Group Index Annual Report'],
          pageName: 'IIPGroupIndexAnnualProductionDetails'
        }



      case '/kanpurreport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'WholeSale Kanpur District', 'Kanpur Report'],
          pageName: 'GetIIPGeneralReport'
        }

      case '/IIPIndexMonthlyComparison':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Index Comparision Report'],
          pageName: 'IndexMonthlyComparison'
        }


      case '/IIPAnnualUB':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Annual Used Based Categorisation'],
          pageName: 'AnnualUBCategorisationReport'
        }


      case '/RCDistrictIndex':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'District Index'],
          pageName: 'DistrictIndex'
        }

        //Urban Consumer Retail Price
      case '/UrbanCurrentPriceReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'Current Price Report'],
          pageName: 'UrbanCurrentPriceReport'
        }
      case '/UrbanDistrictIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'District Index'],
          pageName: 'UrbanDistrictIndexReport'
        }
      case '/UrbanWestIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'West Index Report'],
          pageName: 'UrbanWestIndexReport'
        }
      case '/PriElectricityReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Agricultural Parity', 'Price Electricity Report'],
          pageName: 'PriElectricityReport'
        }
      case '/priwagesratesreport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Agricultural Parity', 'Wages Rates Report'],
          pageName: 'priwagesratesreport'
        }
      case '/PriBullReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Agricultural Parity', 'Bull Report'],
          pageName: 'PriBullReport'
        }
      case '/privariationreport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Sixty Seven Necessary Items', 'Variation Report'],
          pageName: 'PriVariation Report'
        }
      case '/PriAgricultureReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Agricultural Parity', 'Price Agriculture Report'],
          pageName: 'PriAgricultureReport'
        }

      case '/IIPUBReport':
        return {
          pagePath: ['Report Generation', 'IIP', 'HQ Report', 'Manufacturing Sector', 'Used Based Report'],
          pageName: 'UBReport'
        }
      case '/RuralCentralIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'Central Index Report'],
          pageName: 'RuralCentralIndexReport'
        }
      case '/RuralDistrictPriceReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'District Price Report'],
          pageName: 'RuralDistrictPriceReport'
        }
      case '/UrbanEastIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'East Index Report'],
          pageName: 'UrbanEastIndexReport'
        }

      case '/UrbanCentralIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'Central Index Report'],
          pageName: 'UrbanCentralIndexReport'
        }
      case '/UrbanStateIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'State Index Report'],
          pageName: 'UrbanStateIndexReport'
        }
      case '/UrbanBundelkhandIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'Bundelkhand Index Report'],
          pageName: 'UrbanBundelkhandIndexReport'
        }
        case '/UrbanRegionalGeneralIndex':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Urban Consumer Retail Price', 'Yearly General Index'],
            pageName: 'UrbanRegionalGeneralIndex'
          }
      case '/RuralWestIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'West Index Report'],
          pageName: 'RuralWestIndexReport'
        }
      case '/RuralEastIndexReport':
      return {
        pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'East Index Report'],
        pageName: 'RuralEastIndexReport'
      }
      case '/RuralStateIndexReport':
        return {
          pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'State Index Report'],
          pageName: 'RuralStateIndexReport'
        }

      case '/RuralBundelkhandIndexReport':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Rural Consumer Retail Price', 'Bundel khand Index Report'],
            pageName: 'RuralBundelkhandIndexReport'
          }
      case '/Priwholesalerawwool':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Whole Sale Raw wool', 'Whole Sale Raw wool Report'],
            pageName: 'Priwholesalerawwool'
          }
      case '/MonthlyWholeSalePriceItemwiseReport':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Wholesale Price Reports', 
              'Monthly WholeSale Price Itemwise Report'],
            pageName: 'MonthlyWholeSalePriceItemwiseReport'
          }
      case '/MonthlyWholeSaleIndexItemwiseReport':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Wholesale Price Reports', 
              'Monthly WholeSale Index Itemwise Report'],
            pageName: 'MonthlyWholeSaleIndexItemwiseReport'
          }
      case '/MajorWPI':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Wholesale Price Reports', 
              'MajorWPI Report'],
            pageName: 'MajorWPI'
          }

      case '/PriAnimalReport':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Wholesale Animal Product ', 'Animal Product Input Report'],
            pageName: 'PriAnimalReport'
          }

      case '/PriListReportRuralWages':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System ', 'List Report Rural Wages'],
            pageName: 'PriListReportRuralWages'
          }

      case '/PriPercentageVartiationSheetRuralWageIndexReport':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System ', 'Percentage Variation Sheet of Rural Wage Index'],
            pageName: 'PriPercentageVartiationSheetRuralWageIndexReport'
          }
      case '/PercentageVariationSheetofUrbanWageIndexReport':
          return {
            pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System ', 'Percentage variation Sheet of Urban Wage Index'],
            pageName: 'PercentageVariationSheetofUrbanWageIndexReport'
          }
      case '/PriRuralWageRegionIndex':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System ', 'Rural Wage Region Index'],
              pageName: 'RuralWageRegionIndex'
            }
      case '/PriceLwsUrbanRegionReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System ', 'Urban Wage Region Index'],
              pageName: 'PriceLwsUrbanRegionReport'
            }

      case '/PriHapurMandiReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System', 'Whole Sale Price Hapur Mandi', 'Price HapurMandi Input Report'],
              pageName: 'PriceHapurMandiInputReport'
            }
      case '/ListReportUrbanWages':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System', 'List Report Urban Wages'],
              pageName: 'ListReportUrbanWages'
            }

      case '/PriWagesIndexReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System', 'Labor Wage Rate Index System', 'Wage Index Report'],
              pageName: 'PriceWagesIndexReport'
            }


      case '/PriRCPI':
              return {
                pagePath: ['Report Generation', 'Price Wages Indices System', 'Agricultural Parity', 'RCPI'],
                pageName: 'PriceRCPI'
              }


      case '/Pri_Agricultural_Parity_Index':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System', 'Agricultural Parity', 'Agricultural Parity Index'],
              pageName: 'Pri_Agricultural_Parity_Index'
            }
      case '/priceLwsAnnualAverageRuralUrbanIndexUP':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Labor Wage Rate Index System','Annual average of Rural & Urban wage index of U.P'],
              pageName: 'priceLwsAnnualAverageRuralUrbanIndexUP'
            }
      case '/Pri67CompilationReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Sixty Seven Necessary Items','Compilation Report'],
              pageName: 'Pri67CompilationReport'
            }

      case '/PriThok1':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Agricultural Parity','Thok 1'],
              pageName: 'PriThok1'
            }
      case '/PriThok2':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Agricultural Parity','Thok 2'],
              pageName: 'PriThok2'
            }
      case '/WholeSalePriceGroupWiseReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Wholesale Price Reports','WholeSalePrice GroupWise Report'],
              pageName: 'WholeSalePriceGroupWiseReport'
            }

        case '/PriWPAnnualIndexpriceReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Wholesale Price Reports','Annual Index Price Report'],
              pageName: 'WholeSaleAnnualIndexPriceReport'
            }
        case '/PercentageVariationReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Rural Consumer Retail Price','Percentage Variation Report'],
              pageName: 'PercentageVariationReport'
            }
        case '/MonthlyIndicesofallRegionandState':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Rural Consumer Retail Price','Monthly Indices of all Region and State'],
              pageName: 'MonthlyIndicesofallRegionandState'
            }
        case '/RuralConsumerOrnamentsReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Rural Consumer Retail Price','Rural Consumer Ornaments Report'],
              pageName: 'RuralConsumerOrnamentsReport'
            }
        case '/PriReviewReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Sixty Seven Necessary Items','Review report'],
              pageName: 'PriReviewReport'
            }

        case '/PriIndexReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Wholesale Price Reports','Index Report'],
              pageName: 'PriIndexReport'
            }

        case '/RuralRegionalGeneralIndex':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Rural Consumer Retail Price','Yearly General Index'],
              pageName: 'RuralRegionalGeneralIndex'
            }

        case '/UrbanPercentageVariationReport':
            return {
              pagePath: ['Report Generation', 'Price Wages Indices System','Urban Consumer Retail Price','Percentage Variation Report'],
              pageName: 'UrbanPercentageVariationReport'
            }

        case '/PriAgricultureParityMiscReport':
              return {
                pagePath: ['Report Generation', 'Price Wages Indices System','Agriculture Parity','Agriculture Parity Misc Report'],
                pageName: 'PriAgricultureParityMiscReport'
              }

        case '/PriWholeSalePriceComparisionReport':
              return {
                pagePath: ['Report Generation', 'Price Wages Indices System','Wholesale Price Reports','WholeSale Price Comparison Report'],
                pageName: 'PriWholeSalePriceComparisionReport'
              }

        case '/MonthlyIndicesofallRegionandStateUrban':
              return {
                pagePath: ['Report Generation', 'Price Wages Indices System','Urban Consumer Retail Price','Monthly Indices of all Region and State'],
                pageName: 'MonthlyIndicesofallRegionandStateUrban'
              }

        case '/PriFinalReport':
              return {
                pagePath: ['Report Generation', 'Price Wages Indices System','Agricultural Parity','Final Report'],
                pageName: 'PriFinalReport'
              }
        case '/UpdateDSLInfo':
                return {
                   pagePath: ['Data Capture', 'ASI','ASI','Master DSL' ],
                   pageName: 'UpdateDSLInfo'
                }
        case '/DataUpload':
                  return {
                    pagePath: ['Data Import', 'Data Upload'],
                    pageName: 'DataUpload'
                  }
      default:
        return {
          pagePath: ['Not Found'],
          pageName: 'Not Found'
        }
    }
  }
};

//conver Date D-M-YYYY Format
export const convertDateFormat = (inputDateString) => {

  const inputDate = new Date(inputDateString);
  const day = inputDate.getDate();
  const month = inputDate.getMonth() + 1;
  const year = inputDate.getFullYear();
  const outputDateString = `${day}-${month}-${year}`;
  return outputDateString;
}

export const getLastFridayOfLastMonth = (fromWeek) => {
  let currentChosenDate = new Date(fromWeek);
  let lastMonth = new Date(currentChosenDate);
  lastMonth.setMonth(lastMonth.getMonth() - 1);

  while (lastMonth.getDay() !== 5) {
    lastMonth.setDate(lastMonth.getDate() + 1);
  }

  if (lastMonth.getMonth() !== currentChosenDate.getMonth() - 1) {
    lastMonth.setDate(lastMonth.getDate() - 7);
  }

  let lastMonthDate = lastMonth.toISOString().split('T')[0];
  return lastMonthDate;
}

export const getLastFridayOfLastYear = (fromDate) => {

  let fromDateObj = new Date(fromDate);
  let today = new Date(fromDateObj);
  let oneYearAgo = new Date(fromDateObj);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  let todayDayOfWeek = today.getDay();
  let oneYearAgoDayOfWeek = oneYearAgo.getDay();
  let dayDifference = (todayDayOfWeek - oneYearAgoDayOfWeek + 7) % 7;
  oneYearAgo.setDate(oneYearAgo.getDate() + dayDifference);
  let lastYearDate = oneYearAgo.toISOString().split('T')[0];
  return lastYearDate;
}


export const getLastWeekDate = (fromDate) => {

  const currentDate = new Date(fromDate);
  const lastWeekDate = new Date(currentDate);
  lastWeekDate.setDate(currentDate.getDate() - 7);
  const formattedDate =
    lastWeekDate.getFullYear() +
    '-' +
    ('0' + (lastWeekDate.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + lastWeekDate.getDate()).slice(-2);
  return formattedDate;
}


export const breakTitle = (title) => {

  const words = title.trim().split(/\s+/);
  const brokenTitle = words.reduce((result, word, index) => {
    if (index % 3 === 0) {
      return result + (index !== 0 ? '\n' : '') + word;
    } else {
      return result + ' ' + word;
    }
  }, '');

  return brokenTitle;
};


export const breakTitleForEverySpace = (title) => {
  // Replace every space with a new line
  const brokenTitle = title.replace(/ /g, '\n');
  return brokenTitle;
};


export const changeDateFormat = (inputDate) => { //inputData like new Data()
  if (!(inputDate instanceof Date)) {
    throw new Error('Invalid input. Please provide a valid Date object.');
  }
  // Format the date manually
  const formattedDate =
    inputDate.getDate().toString().padStart(2, '0') + '/' +
    (inputDate.getMonth() + 1).toString().padStart(2, '0') + '/' +
    inputDate.getFullYear() + ' ' +
    (inputDate.getHours() % 12 || 12).toString().padStart(2, '0') + ':' +
    inputDate.getMinutes().toString().padStart(2, '0') + ' ' +
    (inputDate.getHours() < 12 ? 'AM' : 'PM');
  return formattedDate; //return Date 14/12/2023 11:51 AM (d/m/y)
}


export const getFormattedDate = (date) => {
  if (!date) return '';
  const monthNames = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
  ];

  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${year}`;
};


export const shortMonthToMonthNumber = (shortMonth) => {
  const monthMapping = {
    JAN: '01',
    FEB: '02',
    MAR: '03',
    APR: '04',
    MAY: '05',
    JUN: '06',
    JUL: '07',
    AUG: '08',
    SEP: '09',
    OCT: '10',
    NOV: '11',
    DEC: '12',
  };
  return monthMapping[shortMonth] || null;
}


export const shortMonthToFull = (shortMonth) => {
  const monthMapping = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
  };
  return monthMapping[shortMonth] || null;
}

export const getMonthList = () => {
  const months = [
    { value: 'JAN', label: 'January' },
    { value: 'FEB', label: 'February' },
    { value: 'MAR', label: 'March' },
    { value: 'APR', label: 'April' },
    { value: 'MAY', label: 'May' },
    { value: 'JUN', label: 'June' },
    { value: 'JUL', label: 'July' },
    { value: 'AUG', label: 'August' },
    { value: 'SEP', label: 'September' },
    { value: 'OCT', label: 'October' },
    { value: 'NOV', label: 'November' },
    { value: 'DEC', label: 'December' },
  ];
  return months;
}


export const getMonthNumberToName = (month) => {
  const months = [
    "JAN", "FEB", "MAR", "APR",
    "MAY", "JUN", "JUL", "AUG", "SEP",
    "OCT", "NOV", "DEC"
  ];

  return months[month - 1];
}

export const getNextYear = (year) => {
  const lastTwoDigits = parseInt(year) % 100;
  const nextTwoDigits = lastTwoDigits + 1;
  return `${year}-${String(nextTwoDigits).padStart(2, '0')}`
};


export const converDateFormat = (originalDate) => {  // format like  2023-04-23T23:11:53.000Z

  const formattedDate = originalDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const formattedTime = originalDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  })
  return `${formattedDate} ${formattedTime}` // return format like April 24, 2023 4:41:53 AM

}

export const validateRolesHapur = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'DISTRICT LEVEL') {
    if (decodedToken.id.USER_LEVEL_LOCATION === '75') {
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === 'DISPRI' || roles[i] === 'DISADM') {
          roleFlag = true;
          break;
        }
      }
    }
  } else if (userLevel === 'DIVISION LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVADM') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQPRI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};

export const validateRolesBull = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQPRI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};

export const validateRoles = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'DISTRICT LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DISPRI' || roles[i] === 'DISADM') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'DIVISION LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVADM' || roles[i] === 'DIVMPR') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQPRI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};



export const validateRolesRowWool = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;
  const districtCode = decodedToken.id.USER_LEVEL_LOCATION;

  if (userLevel === 'DISTRICT LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DISPRI' || roles[i] === 'DISADM') {
        roleFlag = true;
        break;
      }
    }
    const allowDistrict = ["28", "36", "45", "64", "68"];
    if (!allowDistrict.includes(districtCode)) {
      roleFlag = false;
    }
  } else if (userLevel === 'DIVISION LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVADM') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQPRI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};

export const validateRolesIIPHQ = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  // Check for FACTOIIP role
  for (let i = 0; i < roles.length; i++) {
    if (roles[i] === 'FACTOIIP') {
      roleFlag = true;
      return roleFlag;
    }
  }

  if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQADM' || roles[i] === 'HQIIP') {
        roleFlag = true;
        break;
      }
    }
  }
  return roleFlag;
};


export const validateRolesKanpur = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }
  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'DISTRICT LEVEL') {
    if (decodedToken.id.USER_LEVEL_LOCATION === "34") {
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === 'DISPRI' || roles[i] === 'DISADM') {
          roleFlag = true;
          break;
        }
      }
    }
  } else if (userLevel === 'DIVISION LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVADM') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQPRI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};



export const validateRolesIIPManufacturing = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  const userTypeCode = decodedToken.id.USER_TYPE_CODE;
  let roleFlag = false;

  // Check for FACTOIIP role
  for (let i = 0; i < roles.length; i++) {
    if (roles[i] === 'FACTOIIP') {
      roleFlag = true;
      return roleFlag;
    }
  }

  if (userLevel === 'DISTRICT LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DISIIP' || roles[i] === 'DISADM') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'DIVISION LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVADM') {
        roleFlag = true;
        break;
      }
    }
  } else if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQADM' || roles[i] === 'HQIIP') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};


export const validateRolesIIPMining = async (decodedToken) => {
  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return false;
  }
  const roles = (decodedToken.id.ROLE_CODE || '').split('|').map((r) => r.trim());
  const userId = String(decodedToken.id.USER_ID || '').trim().toUpperCase();
  const userName = String(decodedToken.id.USER_NAME || '').trim().toUpperCase();
  if (['IIPMINE', 'HQIIPMINE', 'HQIIPM'].includes(userId) || ['IIPMINE', 'HQIIPMINE'].includes(userName)) {
    return true;
  }
  return roles.some((role) => ['HQIIPM', 'IIPMine', 'HQIIPMine', 'HQIIP', 'HQADM'].includes(role));
};

export const validateRolesIIPElectricity = async (decodedToken) => {
  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return false;
  }
  const roles = (decodedToken.id.ROLE_CODE || '').split('|').map((r) => r.trim());
  const userId = String(decodedToken.id.USER_ID || '').trim().toUpperCase();
  const userName = String(decodedToken.id.USER_NAME || '').trim().toUpperCase();
  if (['IIPELEC', 'HQIIPELEC', 'HQIIPE'].includes(userId) || ['IIPELEC', 'HQIIPELEC'].includes(userName)) {
    return true;
  }
  return roles.some((role) => ['HQIIPE', 'IIPElec', 'HQIIPElec', 'HQIIP', 'HQADM'].includes(role));
};

export const validateRolesIIP = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  const userTypeCode = decodedToken.id.USER_TYPE_CODE;
  const userId = String(decodedToken.id.USER_ID || '').trim().toUpperCase();
  const userName = String(decodedToken.id.USER_NAME || '').trim().toUpperCase();
  let roleFlag = false;

  // Mining / Electricity dedicated users (USER_ID based)
  if (
    ['IIPMINE', 'HQIIPMINE', 'HQIIPM', 'IIPELEC', 'HQIIPELEC', 'HQIIPE'].includes(userId) ||
    ['IIPMINE', 'HQIIPMINE', 'IIPELEC', 'HQIIPELEC'].includes(userName)
  ) {
    return true;
  }

  // Check for FACTOIIP role (FACTO role should not have IIP access)
  for (let i = 0; i < roles.length; i++) {
    if (roles[i] === 'FACTOIIP') {
      roleFlag = true;
      return roleFlag;
    }
  }

  // If user has FACTO role, do not allow IIP access
  for (let i = 0; i < roles.length; i++) {
    if (roles[i] === 'FACTO') {
      return false;
    }
  }

  // Check for HQ, DIV, and DIS level IIP roles
  for (let i = 0; i < roles.length; i++) {
    if (roles[i] === 'HQIIP' || roles[i] === 'HQADM' || roles[i] === 'HQIIPM' || roles[i] === 'HQIIPE' || roles[i] === 'IIPMine' || roles[i] === 'HQIIPMine' || roles[i] === 'IIPElec' || roles[i] === 'HQIIPElec' || roles[i] === 'DIVIIP' || roles[i] === 'DISIIP' || roles[i] === 'DIVADM' || roles[i] === 'DISADM') {
      roleFlag = true;
      break;
    }
  }
  return roleFlag;
};

export const validateRolesASI = async (decodedToken) => {
  let roleFlag = false;

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return roleFlag;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');

  if (
    userLevel === 'HEAD QUARTER' ||
    userLevel === 'DIVISION LEVEL' ||
    userLevel === 'FACTORY LEVEL' ||
    userLevel === 'DISTRICT LEVEL'
  ) {
    for (let i = 0; i < roles.length; i++) {
      if (
        roles[i] === 'DIVASI' ||
        roles[i] === 'DIVADM' ||
        roles[i] === 'HQASI' ||
        roles[i] === 'HQADM' ||
        roles[i] === 'FACTO' ||
        roles[i] === 'DISASI'
      ) {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};


export const validateASIReportsRoleHQ = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'HEAD QUARTER') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQASI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};

export const validateASIReportsRoleDIS = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'DISTRICT LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'HQADM' || roles[i] === 'DISASI') {
        roleFlag = true;
        break;
      }
    }
  }
  return roleFlag;
};

export const validateASIReportsRoleDIV = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel === 'DIVISION LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVASI' || roles[i] === 'HQADM') {
        roleFlag = true;
        break;
      }
    }
  }
  return roleFlag;
};

export const validateASIReportsRole = async (decodedToken) => {

  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return;
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');
  let roleFlag = false;

  if (userLevel == 'HEAD QUARTER' || userLevel == 'DIVISION LEVEL' || userLevel == 'DISTRICT LEVEL') {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'DIVASI' || roles[i] === 'DIVADM' || roles[i] === 'HQASI' || roles[i] === 'HQADM' || roles[i] === 'DISASI') {
        roleFlag = true;
        break;
      }
    }
  }

  return roleFlag;
};



/** When status flag is 6, only DIVASI role at DIVISION LEVEL may edit (Save/Next enabled). */
export const isAsiStatusSixEditAllowedForRole = (decodedToken) => {
  const userType = decodedToken?.id?.USER_TYPE;
  const roleCodeRaw = decodedToken?.id?.ROLE_CODE;
  const roles =
    typeof roleCodeRaw === 'string'
      ? roleCodeRaw.split('|').map((r) => String(r).trim()).filter(Boolean)
      : [];
  return userType === 'DIVISION LEVEL' && roles.includes('DIVASI');
};

/** HEAD QUARTER ASI workflow: HQADM aur HQASI dono ko same button rights (Block A–N). */
export const isHqAsiAdminRole = (roles) => {
  const list = Array.isArray(roles)
    ? roles
    : typeof roles === 'string'
      ? roles.split('|')
      : [];
  const r = list.map((x) => String(x).trim().toUpperCase());
  return r.includes('HQADM') || r.includes('HQASI');
};

export const validateButtonASIBlock = async (decodedToken, statusFlage) => {
  const sf = String(statusFlage ?? '').trim();
  const ut = decodedToken?.id?.USER_TYPE;
  const roleCodeRaw0 = decodedToken?.id?.ROLE_CODE;
  const roles0 =
    typeof roleCodeRaw0 === 'string'
      ? roleCodeRaw0.split('|').map((r) => String(r).trim()).filter(Boolean)
      : [];

  // "" → sab user Save/Next on
  if (sf === '') {
    return false;
  }

  // FACTORY LEVEL: Save/Next "9" (District Reject) par; "5" (Factory save complete) par FACTO bhi edit kar sakta hai
  if (ut === 'FACTORY LEVEL') {
    if (sf === '5' && roles0.includes('FACTO')) {
      return false;
    }
    return sf !== '9';
  }

  // 5 = Factory ne Save kiya → DISTRICT edit; FACTO + FACTORY LEVEL bhi (upar handle); baaki band
  if (sf === '5') {
    return ut !== 'DISTRICT LEVEL';
  }

  // 0 = District Save → sirf DISTRICT; Factory, Division, HQ band
  if (sf === '0') {
    return ut !== 'DISTRICT LEVEL';
  }

  // 9 = District Reject → Factory upar handle; District/Division/HQ A–M band
  if (sf === '9') {
    return true;
  }

  // 2 = Division Save
  if (sf === '2') {
    return ut !== 'DIVISION LEVEL';
  }

  if (sf === '6') {
    return !isAsiStatusSixEditAllowedForRole(decodedToken);
  }

  // 3 = Division Submit ho chuka → sirf HQ (HQADM/HQASI); District/Division/Factory A–M band
  if (sf === '3') {
    if (ut === 'HEAD QUARTER' && isHqAsiAdminRole(roles0)) {
      return false;
    }
    return true;
  }

  // 4 = Division Reject → sirf District (DISASI) edit; Division/HQ/Factory band
  if (sf === '4') {
    if (ut === 'DISTRICT LEVEL' && roles0.includes('DISASI')) {
      return false;
    }
    return true;
  }

  // 8 = HQ Accept complete / lock — sab user (HEAD QUARTER samet) A–M band
  if (sf === '8') {
    return true;
  }

  // 7 = HQ Save — sirf HEAD QUARTER
  if (sf === '7') {
    return ut !== 'HEAD QUARTER';
  }

  // 1 = District Submit → Division on; HQADM/HQASI band
  if (sf === '1') {
    if (isHqAsiAdminRole(roles0)) {
      return true;
    }
    if (ut === 'DISTRICT LEVEL' && roles0.includes('DISASI')) {
      return true;
    }
    if (ut === 'DIVISION LEVEL') {
      return false;
    }
    return true;
  }

  const accessLevel = decodedToken.id.USER_TYPE;
  let duser = 0;
  if (accessLevel === 'DIVISION LEVEL') {
    if (statusFlage === "3" || statusFlage === "7" || statusFlage === "8") {
      duser = 1;
    }
  }
  if (accessLevel === 'FACTORY LEVEL' || accessLevel === 'DISTRICT LEVEL') {
    if (statusFlage === "3")
      duser = 1;
  }
  if (accessLevel === 'HEAD QUARTER') {
    if (statusFlage === "2" || statusFlage === "6" || statusFlage === "8") {
      duser = 1;
    }
    if (statusFlage === "3") {
      duser = 2;
    }

  }
  if (duser === 0) {
    return false;
  }
  return true;
};


export const getUserRole = (loginInfo) => {
  let userRoleObject = {}
  userRoleObject.userRoleType = false;
  if (loginInfo.ROLE_CODE === 'SUPER' && loginInfo.USER_TYPE_CODE === '0') {
    userRoleObject.userRoleType = "SUPER ADMIN USER";
  }
  return userRoleObject
}


export const isNumeric = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

/**
 * IIP Value display: years <= 2025 are stored ×1000 (show ÷1000); from 2026 show as-is.
 * @param {*} rawValue
 * @param {string|number} year
 * @param {boolean} [emptyAsZero=false] - reports: true → '0.00'; forms: false → ''
 */
export const formatIipValueByYear = (rawValue, year, emptyAsZero = false) => {
  const emptyResult = emptyAsZero ? '0.00' : '';
  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return emptyResult;
  }
  const num = parseFloat(rawValue);
  if (Number.isNaN(num)) {
    return emptyResult;
  }
  const y = parseInt(year, 10);
  const displayVal = !Number.isNaN(y) && y <= 2025 ? num / 1000 : num;
  return displayVal.toFixed(2);
};

/** Inverse of formatIipValueByYear for save: years <= 2025 store ×1000 */
export const toIipStorageValueByYear = (rawValue, year) => {
  if (rawValue === null || rawValue === undefined || rawValue === '') return '';
  const num = parseFloat(rawValue);
  if (Number.isNaN(num)) return '';
  const y = parseInt(year, 10);
  const storageVal = !Number.isNaN(y) && y <= 2025 ? Number((num * 1000).toFixed(2)) : num;
  return String(storageVal);
};

/**
 * Map previous month/year IIP report row to current row by industryCode (+ item when present).
 */
export const findIipPrevReportByIndustryCode = (rows = [], currentItem = {}) => {
  if (!Array.isArray(rows) || !currentItem) return {};
  const industryCode = String(currentItem.industryCode ?? '').trim();
  if (!industryCode) return {};

  const itemCode = String(currentItem.item ?? currentItem.nIC5Digit ?? '').trim();
  if (itemCode) {
    const matchedByCodeAndItem = rows.find(
      (row) =>
        String(row.industryCode ?? '').trim() === industryCode &&
        String(row.item ?? row.nIC5Digit ?? '').trim() === itemCode
    );
    if (matchedByCodeAndItem) return matchedByCodeAndItem;
  }

  return rows.find((row) => String(row.industryCode ?? '').trim() === industryCode) || {};
};


export const handleUserLevelAccessPermissions = (decodedToken) => {
  if (!decodedToken || !decodedToken.id) {
    console.error('Invalid or missing user information in the decoded token.');
    return {};
  }

  const userLevel = decodedToken.id.USER_TYPE;
  const roles = decodedToken.id.ROLE_CODE.split('|');

  // return {
  //   userLevel: userLevel || '', 
  //   roles:roles || "''" // Set to a string "''" if roles is falsy
  // };
  let levelObject = {};
  switch (userLevel) {
    case "DISTRICT LEVEL":
      levelObject.userLevel = 'DISTRICT LEVEL'
      levelObject.roles = roles || "''"
      levelObject.isVisible = true
      return levelObject;
    case "DIVISION LEVEL":
      levelObject.userLevel = 'DIVISION LEVEL'
      levelObject.roles = roles || "''"
      levelObject.isVisible = true
      return levelObject;
    case "HEAD QUARTER":
      levelObject.userLevel = 'HEAD QUARTER'
      levelObject.roles = roles || "''"
      levelObject.isVisible = true
      return levelObject;
    case "FACTORY LEVEL":
      levelObject.userLevel = 'FACTORY LEVEL'
      levelObject.roles = roles || "''"
      levelObject.isVisible = true
      return levelObject;
    default:
      levelObject.userLevel = ''
      levelObject.roles = roles || "''"
      levelObject.isVisible = false
      return levelObject;

  }
};


export const getAllYears = () => {
  const currentYear = new Date().getFullYear();
  const yearsArray = [];
  for (let year = currentYear; year >= 2021; year--) {
    yearsArray.push(year);
  }
  return yearsArray;
};

export const validateMonthYears = (selectedYear, selectedMonth) => {
  // selectedYear=2023
  // selectedMonth=MAR
  const sysDate = new Date();
  const systemYear = sysDate.getFullYear();
  const currentMonth = sysDate.getMonth() + 1;
  if (parseInt(selectedYear, 10) > systemYear) {
    toast.error(messages.INVALID_YAER, messages.COLOR_RED);
    return false;
  } else if (
    parseInt(selectedYear, 10) === systemYear &&
    shortMonthToMonthNumber(selectedMonth) > currentMonth
  ) {
    toast.error(messages.INVALID_MONTH, messages.COLOR_RED);
    return false;
  }

  return true;


};

export const isMonthAndYearEmpty = (monthName, yearName) => {
  if (monthName === '') {
    toast.error(messages.MONTH_NAME_MSG, messages.COLOR_RED);
    return false;
  }
  if (yearName === '') {
    toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
    return false;
  }

  return true

}





export const getStatusFlagValue = (actionButton, userLevel) => {
  let statusFlag = '';
  actionButton = actionButton.toLowerCase();
  userLevel = userLevel.toLowerCase();


  if (actionButton === 'save' && userLevel === "district level") {
    statusFlag = "0";
  }
  else if (actionButton === 'submit' && userLevel === "district level") {
    statusFlag = "1";
  }
  else if (actionButton === 'save' && userLevel === "division level") {
    statusFlag = "2";
  }
  else if (actionButton === 'submit' && userLevel === "division level") {
    statusFlag = "3";
  }
  else if (actionButton === 'reject' && userLevel === "division level")/// not use
  {
    statusFlag = "4";
  }
  else if (actionButton === 'save' && userLevel === "head quarter") {
    statusFlag = "7";
  }
  else if (actionButton === 'accept' && userLevel === "head quarter") {
    statusFlag = "8";
  }
  else if (actionButton === 'reject' && userLevel === "head quarter") {
    statusFlag = "6";
  }
  else if(actionButton === 'submit' && userLevel === "head quarter"){
    statusFlag = "1";
  }
  else if (actionButton === 'save' && userLevel === "factory level") // new condtion for factory level save button
  {
    // statusFlag = "8"; commented on date 18/12/2024
    statusFlag = "5";
  }
  return statusFlag

}

export const getFridayDates = (year, month) => {

  const dates = [];
  const storedLanguage = localStorage.getItem('language');
  let string=''
  if(storedLanguage=== 'hi'){
     string = ['\u092a\u094d\u0930\u0925\u092e\u0020\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930', 
      '\u0926\u0942\u0938\u0930\u093e\u0020\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930', 
      '\u0924\u0940\u0938\u0930\u093e\u0020\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930',
       '\u091a\u094c\u0925\u093e\u0020\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930', 
       '\u092a\u093e\u0902\u091a\u0935\u093e\u0902\u0020\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930'];
    }else{
     string = ['First Friday', 'Second Friday', 'Third Friday', 'Fourth Friday', 'Fifth Friday'];
    }

 
  const firstDayOfMonth = new Date(year, month - 1, 1); // Month is zero-based
  const lastDayOfMonth = new Date(year, month, 0).getDate(); // Get the last day of the month

  for (let day = 1; day <= lastDayOfMonth; day++) {
    const currentDate = new Date(year, month - 1, day);
    if (currentDate.getDay() === 5) { // Friday is represented by 5
      const fridayString = string[dates.length];
      const formattedDate = currentDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
      dates.push(`${fridayString} - ${formattedDate}`);
    }
  }

  return dates;
}



export const getButtonDisabledStates = (payload, buttonAccessObject) => {
  const keys = Object.keys(payload);

  if (keys.length === 0) {
    payload = '';
  }

  let isSaveBtnDisable = false;
  let isSubmitBtnDisable = false;
  let isAcceptBtnDisable = false;
  let isRejectBtnDisable = false;

  if (payload) {
    const { userLevel } = buttonAccessObject;
    const statusFlagSet = payload.statusFlagSet ?? payload.statusFlag ?? '';
    if (statusFlagSet === '' || statusFlagSet === '0' || statusFlagSet == null) {
      return { isSaveBtnDisable: false, isSubmitBtnDisable: false, isAcceptBtnDisable: false, isRejectBtnDisable: false };
    }

    if (userLevel === 'DISTRICT LEVEL') {

      if (statusFlagSet === '2' || statusFlagSet === '3') {  //old
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }

      if (statusFlagSet === '1') {//new
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }
      if (statusFlagSet === '7') { //new
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }

      if (statusFlagSet === '8') { //new 7/25/2024
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }

    } else if (userLevel === 'DIVISION LEVEL') {

      if (statusFlagSet === '0' || statusFlagSet === '1') {
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
        // isAcceptBtnDisable = true;
        // isRejectBtnDisable = true;
      }


      if (statusFlagSet === '3') { //new
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }
      if (statusFlagSet === '7') { //new
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }

      if (statusFlagSet === '8') { //new 7/25/2024
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }


    } else if (userLevel === 'HEAD QUARTER') {

      if (statusFlagSet === '6') { //new
        isRejectBtnDisable = true;
        isAcceptBtnDisable = true;
        isSaveBtnDisable = true;
      }

      if (statusFlagSet === '0') { //new
        isAcceptBtnDisable = true;
        isRejectBtnDisable = true;
        isSaveBtnDisable = true;
      }
      if (statusFlagSet === '2') { //new
        isAcceptBtnDisable = true;
        isRejectBtnDisable = true;
        isSaveBtnDisable = true;
      }


      if ((statusFlagSet === '1' || statusFlagSet === '3')) {
        isSaveBtnDisable = true;
      }
      if (statusFlagSet === '1') { // 16 feb 2026
          isSubmitBtnDisable = true;
      }
      if (statusFlagSet === '8') { //new - after HQ Accept, disable all action buttons
        isAcceptBtnDisable = true;
        isRejectBtnDisable = true;
        isSaveBtnDisable = true;
        isSubmitBtnDisable = true;
      }

      // isAcceptBtnDisable=true;
    }

  }

  return {
    isSaveBtnDisable,
    isSubmitBtnDisable,
    isAcceptBtnDisable,
    isRejectBtnDisable
  };
}


export const generateYearRange = (startYear) => {
  const endYear = startYear + 1;
  return `${startYear}-${endYear}`;
}


export const getPreviousAlphabet = (alphabet) => {
  const alphabetLowerCase = alphabet.toLowerCase();
  if (alphabetLowerCase === 'a') {
    return 'z';
  } else {
    const charCode = alphabetLowerCase.charCodeAt(0);
    const previousCharCode = charCode - 1;
    return String.fromCharCode(previousCharCode);
  }
}

export const alphabetIndex = (letter) => {
  const numericValue = letter.charCodeAt(0) - 64; // A = 65, so A -> 65 - 64 = 1, B -> 66 - 64 = 2, and so on
  return numericValue;
};

export const generateRandomNumber = () => {
  const min = 10000; // Minimum 5-digit number
  const max = 99999; // Maximum 5-digit number
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  return randomNumber;
}



export const addMonthsToDateString=(dateString, monthsToAdd)=> { // "JAN 2024" ,"1"
  // Define month abbreviations
  const monthMap = {
      'JAN': 0,
      'FEB': 1,
      'MAR': 2,
      'APR': 3,
      'MAY': 4,
      'JUN': 5,
      'JUL': 6,
      'AUG': 7,
      'SEP': 8,
      'OCT': 9,
      'NOV': 10,
      'DEC': 11
  };


  const [monthAbbrev, year] = dateString.split(' ');
  const month = monthMap[monthAbbrev];
  const parsedYear = parseInt(year, 10);
  let date = new Date(parsedYear, month, 1);
  date.setMonth(date.getMonth() + monthsToAdd);
  const resultMonthAbbrev = Object.keys(monthMap)[date.getMonth()];
  const resultYear = date.getFullYear();
  return `${resultMonthAbbrev} ${resultYear}`; //  return "FEB 2024" ,"1"
}




export const formatDate = (dateString) => {  //2023-01-01
  const date = new Date(dateString);
  const monthOptions = { month: 'short' };
  const yearOptions = { year: '2-digit' };
  const month = new Intl.DateTimeFormat('en-US', monthOptions).format(date);
  const year = new Intl.DateTimeFormat('en-US', yearOptions).format(date);
  return `${month}-${year}`;
  
  //Feb-23
};

export const formatDateWithFourDigitYear = (dateString) => {  //2023-01-01
  const date = new Date(dateString);
  const monthOptions = { month: 'short' };
  const yearOptions = { year: 'numeric' };
  const month = new Intl.DateTimeFormat('en-US', monthOptions).format(date);
  const year = new Intl.DateTimeFormat('en-US', yearOptions).format(date);
  return `${month}-${year}`;
  
  //Feb-2023
};


export const isEndDateGreater = (startDate,endDate) => {
  const sDate = new Date(startDate);
  const eDate = new Date(endDate);
  // Check if endDate is greater than startDate
   return eDate >= sDate;
}


export const getMonthRange = (dateString, monthsToAdd) => { // "JAN 2024" ,"1"
  // Define month abbreviations
  const monthMap = {
    'JAN': 0,
    'FEB': 1,
    'MAR': 2,
    'APR': 3,
    'MAY': 4,
    'JUN': 5,
    'JUL': 6,
    'AUG': 7,
    'SEP': 8,
    'OCT': 9,
    'NOV': 10,
    'DEC': 11
  };

  // Reverse map to convert numbers back to month abbreviations
  const reverseMonthMap = Object.fromEntries(Object.entries(monthMap).map(([k, v]) => [v, k]));

  const [startMonthAbbrev, startYear] = dateString.split(' ');
  const startMonth = monthMap[startMonthAbbrev];
  const parsedStartYear = parseInt(startYear, 10);

  // Calculate the start and end dates
  const startDate = new Date(parsedStartYear, startMonth, 1);
  const endDate = new Date(startDate);
  endDate.setMonth(startDate.getMonth() + monthsToAdd);

  // Generate an array of month strings
  const monthsArray = [];
  for (let date = new Date(startDate); date <= endDate; date.setMonth(date.getMonth() + 1)) {
    const monthAbbrev = reverseMonthMap[date.getMonth()];
    const year = date.getFullYear();
    monthsArray.push(`${monthAbbrev} ${year}`);
  }
  return monthsArray;
  // 'JAN 2024', 'FEB 2024', 'MAR 2024 '
}


export const getMonthsBetween = (startDate, endDate,heading='') => {// June 2024 //August 2024
  const months = [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  while (start <= end) {
      const year = start.getFullYear().toString().slice(-2);
      // const year = start.getFullYear();
      const month = start.toLocaleString('default', { month: 'short' });
      months.push(`${heading} ${month}-${year}`);
      start.setMonth(start.getMonth() + 1);
  }

  return months;
};


export const generateSurveyYears = () => {
  let startYear=2013;
  let endYear=2024;
 
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
      years.push(`${year}-${(year + 1).toString().slice(2)}`);
  }
  years.reverse();
   return years;
};

/**
 * Generic function to delete a single row from table data
 * Used across multiple pages like InputItemsIndigenous, InputItemsImported, etc.
 * 
 * @param {number} index - The index of the row to delete
 * @param {object} itemData - Current item data state
 * @param {function} setItemData - State setter for item data
 * @param {number} maxEditableRows - Maximum number of user editable rows (default: 10)
 * @param {boolean} showConfirmation - Whether to show confirmation dialog (default: true)
 * @returns {boolean} - Returns true if deletion was successful, false otherwise
 */
export const handleDeleteTableRow = (index, itemData, setItemData, maxEditableRows = 10, showConfirmation = true) => {
  // Only allow deletion for user editable rows (first maxEditableRows rows)
  if (index >= maxEditableRows) {
    toast.warning('Cannot delete system rows', messages.COLOR_RED);
    return false;
  }

  const item = itemData[index];
  
  // Show confirmation alert before deletion if enabled
  if (showConfirmation) {
    const confirmMessage = `Are you sure you want to delete Row ${index + 1}?${item?.itemDesc ? `\n\nItem: ${item.itemDesc}` : ''}${item?.itemCode ? `\nItem Code: ${item.itemCode}` : ''}`;
    const confirmDelete = window.confirm(confirmMessage);

    if (!confirmDelete) {
      return false; // User cancelled deletion
    }
  }

  // Delete the row and reindex remaining items
  const newItemData = { ...itemData };
  delete newItemData[index];

  // Reindex the remaining items (shifts all rows up)
  const reindexedData = {};
  Object.values(newItemData).forEach((rowItem, newIndex) => {
    reindexedData[newIndex] = { ...rowItem, id: newIndex };
  });

  setItemData(reindexedData);
  
  toast.success(`Row ${index + 1} deleted successfully`, messages.COLOR_GREEN);
  return true;
};

/**
 * Generic function to filter remarks list based on selected Items and Columns
 * Used across multiple pages like FixedAssets, BalanceSheetData, InputItemsImported, etc.
 * 
 * @param {Array} remarksList - Array of remarks objects to filter
 * @param {Object} remarksData - Object containing remarksBlock and remarksItems
 * @param {string} remarksData.remarksBlock - Selected item/block (e.g., 'ALL', 'SELECT_REMARKS', 'SELECT_ITEM', or specific item)
 * @param {string} remarksData.remarksItems - Selected column (optional)
 * @returns {Array} - Filtered remarks list
 */
export const filterRemarksList = (remarksList, remarksData) => {
  if (!remarksList || remarksList.length === 0) {
    return [];
  }

  // If "SELECT_REMARKS" or "SELECT_ITEM" is selected, return empty array
  if (remarksData.remarksBlock === 'SELECT_REMARKS' || remarksData.remarksBlock === 'SELECT_ITEM') {
    return [];
  }

  const selectedBlockRaw = (remarksData?.remarksBlock ?? '').toString().trim();
  const selectedItemRaw = (remarksData?.remarksItems ?? '').toString().trim();

  // Helpers to normalize fields across different pages/components (support alternate API keys for Item* filter)
  const getRemarkBlocks = (remark) => (remark?.blocks ?? remark?.block ?? '').toString().trim();
  const getRemarkItems = (remark) => (remark?.items ?? remark?.Items ?? remark?.itemNo ?? remark?.itemCode ?? remark?.itemDescription ?? '').toString().trim();
  const getRemarkColumns = (remark) => (remark?.columns ?? remark?.columnsName ?? remark?.columns_name ?? '').toString().trim();

  // Normalize block string to single letter for comparison (e.g. "Block A" -> "A", "BlockA" -> "A", "A" -> "A")
  const normalizeBlockToLetter = (blockStr) => {
    const s = (blockStr ?? '').toString().trim();
    if (!s) return '';
    const m = s.match(/Block\s*([A-Za-z])(?:\s|$)/i) || s.match(/^\s*([A-Za-z])\s*$/);
    if (m && m[1]) return m[1].toUpperCase();
    if (s.length === 1) return s.toUpperCase();
    return s.toUpperCase();
  };

  // Normalize selected block ("Block H" -> "H", "A" -> "A")
  const selectedBlockLetter = (() => {
    if (!selectedBlockRaw || selectedBlockRaw === 'ALL') return '';
    return normalizeBlockToLetter(selectedBlockRaw);
  })();

  // Heuristic: if selectedItemRaw is a simple column indicator, treat as column filter.
  // Otherwise (e.g. "1) 3413901-2-ethyl hexanol"), treat as item filter.
  const isColumnSelection = /^\(?\d+\)?$/.test(selectedItemRaw);

  // Normalize item for comparison: "2. PSL No.", "Item 2", "5. Industry code..." -> extract first number for match
  const normalizeItemForFilter = (itemStr) => {
    const s = (itemStr ?? '').toString().trim();
    if (!s || s === 'ALL') return s;
    const numMatch = s.match(/^(?:Item\s*)?(\d+)(?:\s*[\.\)]\s*|$)/i) || s.match(/^(\d+)/) || s.match(/(\d+)/);
    if (numMatch && numMatch[1]) return numMatch[1];
    return s;
  };

  return remarksList.filter((remark) => {
    const remarkBlocks = getRemarkBlocks(remark);
    // Item column value (same as displayed in Remarks list table)
    const remarkItems = getRemarkItems(remark).trim();
    const remarkColumns = getRemarkColumns(remark);

    // **Block filter**
    const remarkBlockLetter = normalizeBlockToLetter(remarkBlocks);
    const blockMatch =
      selectedBlockRaw === 'ALL' ||
      !selectedBlockRaw ||
      !selectedBlockLetter ||
      remarkBlockLetter === selectedBlockLetter;

    // **Item filter** – Item* dropdown selection filters by Item column only
    // Show row when: no item selected / ALL selected, OR Item column matches selected value
    const selectedItemNorm = normalizeItemForFilter(selectedItemRaw);
    const remarkItemNorm = normalizeItemForFilter(remarkItems);
    const remarkItemsLower = (remarkItems ?? '').toString().toLowerCase().trim();
    const selectedItemLower = (selectedItemRaw ?? '').toString().toLowerCase().trim();
    const exactMatch = remarkItems === selectedItemRaw;
    const normalizedMatch = Boolean(selectedItemNorm && remarkItemNorm && selectedItemNorm === remarkItemNorm);
    const containsMatch = Boolean(remarkItemsLower && selectedItemLower && (remarkItemsLower.includes(selectedItemLower) || selectedItemLower.includes(remarkItemsLower)));
    const itemMatch =
      !selectedItemRaw ||
      selectedItemRaw === 'ALL' ||
      isColumnSelection ||
      exactMatch ||
      normalizedMatch ||
      containsMatch;

    // **Column filter**
    // - If selection looks like a column number, filter by remark.columns
    const columnMatch =
      !selectedItemRaw ||
      !isColumnSelection ||
      remarkColumns === selectedItemRaw.replace(/[()]/g, '');

    // Backward-compatible: some pages use remarksBlock to mean "item"
    // If selectedBlock isn't a block-letter selection (e.g. not "Block H") and is not ALL,
    // we treat it as item match (old behavior).
    const legacyItemsMatch =
      selectedBlockRaw === 'ALL' ||
      !selectedBlockRaw ||
      selectedBlockLetter ||
      remarkItems === selectedBlockRaw;

    return blockMatch && itemMatch && columnMatch && legacyItemsMatch;
  });
};

const ASI_PRINT_PREVIEW_KEY = 'asiPrintPreviewActive';

export const setAsiPrintPreviewActive = (active) => {
  if (active) {
    sessionStorage.setItem(ASI_PRINT_PREVIEW_KEY, '1');
  } else {
    sessionStorage.removeItem(ASI_PRINT_PREVIEW_KEY);
  }
};

export const isAsiPrintPreviewActive = () =>
  sessionStorage.getItem(ASI_PRINT_PREVIEW_KEY) === '1';

export const showAppLoading = (visible) => {
  if (isAsiPrintPreviewActive()) return;
  showLoading(visible);
};